import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TimelineSection() {
  const timelineEvents = [{
    day: 'Día 1-7',
    title: 'Adiós a la inflamación',
    desc: 'Notarás tu abdomen más plano y tus niveles de energía estables.'
  }, {
    day: 'Día 8-14',
    title: 'Flexibilidad metabólica',
    desc: 'Tu cuerpo empieza a usar su propia grasa como combustible (adiós antojos de dulce).'
  }, {
    day: 'Día 15-21',
    title: 'Consolidación',
    desc: 'Una nueva relación con la comida donde tú tienes el control, no el hambre.'
  }];
  return <section className="py-16 px-4 bg-white/40" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-bold text-center text-[#2D1B06] mb-16" data-id="element-116">
          Lo que vas a lograr en <span className="text-[#E8820C]" data-id="element-117">21 Días</span>
        </motion.h2>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-gradient-to-b before:from-[#E8820C] before:to-[#E8820C]/20" data-id="element-118">
          {timelineEvents.map((event, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -50 : 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active`} data-id="element-119">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-[#FFF9F0] bg-[#E8820C] text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-120">
                <CheckCircle2 className="w-5 h-5" data-id="element-121" />
              </div>

              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white p-6 rounded-2xl shadow-lg border border-[#E8820C]/10 hover:border-[#E8820C]/30 transition-colors" data-id="element-122">
                <div className="flex items-center justify-between mb-2" data-id="element-123">
                  <span className="font-bold text-[#E8820C] text-sm uppercase tracking-wider" data-id="element-124">
                    {event.day}
                  </span>
                </div>
                <h3 className="font-bold text-xl text-[#2D1B06] mb-2" data-id="element-125">
                  {event.title}
                </h3>
                <p className="text-[#2D1B06]/70 leading-relaxed" data-id="element-126">
                  {event.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}